"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboardOld = exports.copyToClipboard = void 0;
const copyToClipboard = async (str) => {
    try {
        await navigator.clipboard.writeText(str);
    }
    catch (error) {
        (0, exports.copyToClipboardOld)(str);
    }
};
exports.copyToClipboard = copyToClipboard;
const copyToClipboardOld = (str) => {
    const el = document.createElement('textarea'); // Create a <textarea> element
    el.value = str; // Set its value to the string that you want copied
    el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
    el.style.position = 'absolute';
    el.style.left = '-9999px'; // Move outside the screen to make it invisible
    document.body.appendChild(el); // Append the <textarea> element to the HTML document
    const sel = document.getSelection();
    if (!sel) {
        return;
    }
    const selected = sel.rangeCount > 0; // Check if there is any content selected previously
    let range = null;
    if (selected) {
        range = sel.getRangeAt(0); // Store selection if found
    }
    // Mark as false to know no selection existed before
    el.select(); // Select the <textarea> content
    document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el); // Remove the <textarea> element
    if (selected && range) {
        // If a selection existed before copying
        sel.removeAllRanges(); // Unselect everything on the HTML document
        sel.addRange(range); // Restore the original selection
    }
};
exports.copyToClipboardOld = copyToClipboardOld;
